import * as React from 'react';
import * as classnames from "classnames"
import doLog from '../../common/log';
// @ts-ignore: Unreachable code error
import Alitalk from '@alife/icbu-alitalk-react';

// import './index.scss';

export default function ContactSupplier(props: any) {
  const {
    className,
    i18n,
    productId,
    productEncryptId,
    productOwnMemberAlitalkEncryptId,
    productIsHang,
    baoAccountIsService,
    baoAccountIsDisplayAssurance,
    bucket,
    umidToken,
    children
  } = props;

  const isXb = baoAccountIsService ? 1 : 0;
  const isDa = baoAccountIsDisplayAssurance ? 1 : 0;
  const href = `//message.alibaba.com/msgsend/contact.htm?action=contact_action&domain=1&id=${productId}&id_f=${productEncryptId}&mloca=main_en_detail&tracelog=tracedetailfeedback&umidToken=${umidToken}`;
  const domdot=`id:3301,ext:'is_xinbao_product=${isXb}|is_display_assurance=${isDa}'`;

   // 场景来源参数
   const scene = {
    fromPage: 'product_detail',
    bizType: 'contact_supplier',
    bucket: bucket || '',
  };

  return (
    <Alitalk
        uid={productOwnMemberAlitalkEncryptId}
        pid={productId}
        bizType={1}
        bizId={productId}
        sceneType="detail"
        action="chatForInquiry"
        inquiryUrl={href} // 打开weblite中打开询盘主表单
        scene={scene} // 场景来源参数
      >
        <div
          id="J-action-cs"
          className={classnames(className, {
            'contact-supplier-with-hang': productIsHang,
          })}
          title={i18n["supplierCard.action.orderBtn"]}
          data-domdot={domdot}
          //@ts-ignore
          spm="dmessage"
          onClick={() => {
            doLog(
            '/sc.details.csBtn',
            'CLK',
            `position=actions`,
          )}
          }
            
        >
              {children}
        </div>
      </Alitalk>
  )
}
